import * as React from 'react'

import { Box, TagColor as Color, Tag } from '@factorialco/deprecated-design-system'
import { PerformanceAgreementStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  status: PerformanceAgreementStatusEnum | 'not_initiated'
}

export const AgreementStatusTag: React.FC<Props> = ({ status }: Props) => {
  switch (status) {
    case 'pending':
      return (
        <Box>
          <Tag inline capitalize type={Color.malibu}>
            {i18n.t('performance_process.agreements.my_agreements.category_pending_signature')}
          </Tag>
        </Box>
      )
    case 'signed':
      return (
        <Box>
          <Tag inline capitalize type={Color.correct}>
            {i18n.t('performance_process.agreements.status.signed')}
          </Tag>
        </Box>
      )
    case 'not_initiated':
      return (
        <Box>
          <Tag inline capitalize type={Color.grey}>
            {i18n.t('performance_process.agreements.my_agreements.category_not_started')}
          </Tag>
        </Box>
      )
    default:
      const _exhaustiveCheck: never = status
      throw new Error(`Unhandled agreement status: ${_exhaustiveCheck}`)
  }
}
